<template>
  <div>
    <c-list
      :data="list.items"
      :columns="cList.columns"
      :total="list.total"
      :page-current="listPageCurrent"
      :search-where="listSearchWhere"
      @selection-change="handleListSelectionChange"
    >
    </c-list>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import RouteParamsMixin from "view-ui-admin/src/mixins/route-params";
import ListMixin from "view-ui-admin/src/mixins/list";

const module = "forms";
const initWhere = {
  att1: {
    $like: ""
  },
  att2: {
    $like: ""
  }
};

@Component({
  mixins: [RouteParamsMixin, ListMixin],
  components: {
  },
  computed: mapState({
    list: state => state[module].list
  })
})
export default class extends Vue {
  data() {

    return {
      cList: {
        columns: [
          {
            title: "分享人",
            key: "att1",
            render: (h, { row }) => h("span", (row['wxSource'] && row['wxSource']['nickName']))
          },
          {
            title: "提交人",
            key: "att2",
            render: (h, { row }) => h("span", (row['wxUser'] && row['wxUser']['nickName']))
          },
          {
            title: "内容",
            key: "data",
            render: (h, { row }) => h("div", ((d) => {
                const hp = [];
                for (var k in d) {
                    hp.push(h('span', k + ":" + d[k]));
                    hp.push(h('br'));
                }
                return hp;
            })(row['data'])),
          },
          {
            title: "提交时间",
            key: "createdAt",
            render: (h, { row }) => h("span", this.$dayjs(row.createdAt).format('YYYY-MM-DD HH:mm:ss')),
            width: 200
          },
        ],
        cSearch: {
          where: this.$helpers.deepCopy(initWhere)
        }
      }
    };
  }

  async beforeRouteUpdate(to, from, next) {
    this.initListSearchWhere(initWhere);
    this.getList();
    next();
  }

  async created() {
    this.initListSearchWhere(initWhere);
    this.getList();
  }

  getList() {

    const type = this.$route.query.type;
    const hasIgnore = {};
    if (type == '01') {
        // 不查看
        hasIgnore['ignoreSchool'] = true;
    }


    return this.$store.dispatch(`${module}/getList`, {
      query: {
        offset: (this.listPageCurrent - 1) * this.$consts.PageSize,
        limit: this.$consts.PageSize,
        ...hasIgnore,
        where: {
            ...(this.listSearchWhere || {}),
            type
        },
        order: [["id", "DESC"]],
       include: [{ model: "WxUser", as: "wxUser" },{ model: "WxUser", as: "wxSource" }]
      }
    });
  }
}
</script>
